import { render, staticRenderFns } from "./reporta5.vue?vue&type=template&id=a3582fd0&"
import script from "./reporta5.vue?vue&type=script&lang=js&"
export * from "./reporta5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports